export default __webpack_public_path__ + "static/media/inactiveListView.9f6381d4.svg";